import { render } from "./groups.vue?vue&type=template&id=7ddab0c5&scoped=true"
import script from "./groups.vue?vue&type=script&lang=js"
export * from "./groups.vue?vue&type=script&lang=js"

import "./groups.vue?vue&type=style&index=0&id=7ddab0c5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddab0c5"]])

export default __exports__